function hasWholeWord(haystack: string, word: string) {
  const re = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`);
  return re.test(haystack);
}

/**
 * Returns a relevance score (0 = no match, higher = better).
 * Tiers:
 *   100 — full query matches as whole word(s) in name
 *    90 — full query matches as whole word(s) in keywords
 *    70 — all query words match as whole words in name
 *    60 — all query words match as whole words across name + keywords
 *    40 — some query words match as whole words in name or keywords
 *    20 — full query is a substring in name (partial, e.g. "car" in "care")
 *    15 — full query is a substring in keywords
 *    10 — subsequence match (typo tolerance)
 *     0 — no match
 */
export function matchScore(
  value: string,
  term: string,
  keywords?: string | null,
): number {
  const target = term.toLowerCase().trim();
  if (!target) return 100;

  const source = value.toLowerCase().trim();
  const kw = (keywords ?? "").toLowerCase();

  if (hasWholeWord(source, target)) return 100;
  if (hasWholeWord(kw, target)) return 90;

  const targetWords = target.split(/\s+/).filter(Boolean);

  if (targetWords.length > 0) {
    const nameWordHits = targetWords.filter((w) => hasWholeWord(source, w));
    const combinedHits = targetWords.filter(
      (w) => hasWholeWord(source, w) || hasWholeWord(kw, w),
    );

    if (nameWordHits.length === targetWords.length) return 70;
    if (combinedHits.length === targetWords.length) return 60;
    if (combinedHits.length > 0) return 40;
  }

  if (source.includes(target)) return 20;
  if (kw.includes(target)) return 15;

  let i = 0;
  let j = 0;
  while (i < source.length && j < target.length) {
    if (source[i] === target[j]) j += 1;
    i += 1;
  }
  if (j === target.length) return 10;

  return 0;
}
